module.exports = __webpack_public_path__ + "static/bsas007-d04655499117a9fb16231715fd0c0d96.jpg";